'use client';

import { c as _c } from "react/compiler-runtime";
import Grid from '@mui/material/Grid';
import { useShallow } from 'zustand/shallow';
import { useBTCalculatorStore } from '../Form/calculatorStore';
import { ResultCard } from './ResultCard';
export const ResultBoxes = () => {
  const $ = _c(13);
  const {
    balanceTransferFee: balanceTransferFee_0,
    interestWithExistingDebt: interestWithExistingDebt_0,
    savings: savings_0
  } = useBTCalculatorStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      bgcolor: "reds.extraLight",
      color: "reds.dark"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== interestWithExistingDebt_0) {
    t1 = <ResultCard className="debt-box" title="If you kept your debt on your current card:" value={interestWithExistingDebt_0} valueAnnotation="total interest payments" subtext="If paid off in equal installments over the same period." sx={t0} />;
    $[1] = interestWithExistingDebt_0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      bgcolor: "blues.lightest",
      color: "blues.dark"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== balanceTransferFee_0) {
    t3 = <ResultCard className="balance-transfer-box" title="If you transfer your balance you will pay:" value={balanceTransferFee_0} valueAnnotation="balance transfer fee" subtext="If debt is paid off within the 0% intro period." sx={t2} />;
    $[4] = balanceTransferFee_0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      bgcolor: "greens.extraLight",
      color: "greens.dark"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== savings_0) {
    t5 = <ResultCard className="savings-box" title="Your savings with a balance transfer will be:" value={savings_0} valueAnnotation="total savings" sx={t4} />;
    $[7] = savings_0;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t5) {
    t6 = <Grid container={true} spacing={3.5}>{t1}{t3}{t5}</Grid>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(t0) {
  const {
    results: t1
  } = t0;
  const {
    balanceTransferFee,
    interestWithExistingDebt,
    savings
  } = t1;
  return {
    balanceTransferFee,
    interestWithExistingDebt,
    savings
  };
}